module.exports = __webpack_public_path__ + "images/hero1.8efd165a045c2d68e0d3bb4818c802a7.jpg";